import { Typography } from "./TypographyStyleGuide";

export const SectionTitle = ({
  title,
  color,
}: {
  title: string;
  color?: string;
}) => (
  <div className="section-title">
    <Typography
      size="large"
      title={title}
      fontWeight="bold"
      style={color ? { color } : undefined}
    />
  </div>
);

export const Header = ({ title }: { title: string }) => (
  <header className="style-guide-header">
    <Typography size="h1" title={title} />
  </header>
);
